module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1065.b8bcb290.png";